export enum IconNames {
  Add = 'add',
  AddFrame = 'add-frame',
  Agility = 'agility',
  AlertInfo = 'alert-info',
  AlertSuccess = 'alert-success',
  AlertWarning = 'alert-warning',
  AlertWarningFilled = 'alert-warning-filled',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowsLeftRight = 'arrows-left-right',
  ArrivingTruck = 'arriving-truck',
  BackLeft = 'back-left',
  Batch = 'batch',
  Box = 'box',
  BoxDelivery = 'box-delivery',
  BoxDeliveryCheckmark = 'box-delivery-checkmark',
  BoxDeliveryConnected = 'box-delivery-connected',
  BoxQuestionmark = 'box-questionmark',
  Broom = 'broom',
  Camera = 'camera',
  Calendar = 'calendar',
  CalendarClock = 'calendar-clock',
  CarClock = 'car-clock',
  Chat = 'chat',
  Checkmark = 'checkmark',
  CheckmarkFrame = 'checkmark-frame',
  CircleSegment = 'circle-segment',
  Clipboard = 'clipboard',
  ClipboardCheckmark = 'clipboard-checkmark',
  Clock = 'clock',
  ClockStop = 'clock-stop',
  Close = 'close',
  Components = 'components',
  ComponentsReservation = 'components-reservation',
  Copy = 'copy',
  Coupling = 'coupling',
  CubeFilled = 'cube-filled',
  DataCenter = 'data-center',
  Decoupling = 'decoupling',
  Delete = 'delete',
  Delivery = 'delivery',
  DeliveryCheckmark = 'delivery-checkmark',
  Document = 'document',
  DocumentAdd = 'document-add',
  DocumentCheck = 'document-check',
  DocumentPdf = 'document-pdf',
  DocumentSettings = 'document-settings',
  DocumentXls = 'document-xls',
  Down = 'down',
  DownloadFrame = 'download-frame',
  Download = 'download',
  DragHandle = 'drag-handle',
  Edit = 'edit',
  EmergencyExit = 'emergency-exit',
  Exit = 'exit',
  Export = 'export',
  ExternalLink = 'external-link',
  Filter = 'filter',
  ForkliftStacking = 'forklift-stacking',
  ForwardRight = 'forward-right',
  Fullscreen = 'fullscreen',
  FullscreenExit = 'fullscreen-exit',
  Garage = 'garage',
  GateOpen = 'gate-open',
  Globe = 'globe',
  HandoverCheck = 'handover-check',
  History = 'history',
  ImageryAdd = 'imagery-add',
  Inbound = 'inbound',
  Interval = 'interval',
  LessMinimize = 'less-minimize',
  Locator = 'locator',
  Logistics = 'logistics',
  LogisticsDock = 'logistics-dock',
  Mail = 'mail',
  Map = 'map',
  MapCity = 'map-city',
  MaterialList = 'material-list',
  Message = 'message',
  Minimize = 'minimize',
  MyBrandFrame = 'my-brand-frame',
  NotificationAdd = 'notification-add',
  NotificationAddFilled = 'notification-add-filled',
  Outbound = 'outbound',
  Options = 'options',
  Paperplane = 'paperplane',
  Parking = 'parking',
  People = 'people',
  PlaneLand = 'plane-land',
  PlaneSide = 'plane-side',
  PlaneStart = 'plane-start',
  PlaneTop = 'plane-top',
  ProblemFrame = 'problem-frame',
  ListView = 'list-view',
  ListViewMobile = 'list-view-mobile',
  LocatorTracking = 'locator-tracking',
  QrCode = 'qr-code',
  QuestionFrame = 'question-frame',
  Redo = 'redo',
  Refresh = 'refresh',
  Registration = 'registration',
  RegisterST = 'register-st',
  Save = 'save',
  Search = 'search',
  SecurityCheck = 'security-check',
  SecurityCheckArrival = 'security-check-arrival',
  SecurityCheckDeparture = 'security-check-departure',
  SealCheck = 'seal-check',
  ServiceAgent = 'service-agent',
  Ship = 'ship',
  ShipSide = 'ship-side',
  ShipDelivery = 'ship-delivery',
  ShipPort = 'ship-port',
  Smartphone = 'smartphone',
  SmartphoneArrowRight = 'smartphone-arrow-right',
  SmartphoneLoadingWheel = 'smartphone-loading-wheel',
  SpeedometerSpeedHigh = 'speedometer-speed-high',
  SteeringWheel = 'steering-wheel',
  Store = 'store',
  Train = 'train',
  TouchPit = 'touch-pit',
  TruckBox = 'truck-box',
  TruckDelivery = 'truck-delivery',
  TruckRelease = 'truck-release',
  TruckSizeS = 'truck-size-s',
  TruckSizeM = 'truck-size-m',
  TruckSizeL = 'truck-size-l',
  TruckSizeXL = 'truck-size-xl',
  TruckSizeXXL = 'truck-size-xxl',
  TruckSizeST = 'truck-size-st',
  TruckSizeXX = 'truck-size-xx',
  TruckSizeXXLDecoupling = 'truck-size-xxl-decoupling',
  TruckSizeXXLCoupling = 'truck-size-xxl-coupling',
  Undo = 'undo',
  Up = 'up',
  Upload = 'upload',
  UserDesktop = 'user-desktop',
  Warehouse = 'warehouse',
  Wishlist = 'wishlist',
  WoodenPalletPackedFull = 'wooden-pallet-packed-full',
  WrenchWarning = 'wrench-warning',
  ZoomIn = 'zoom-in',
}
